import { useEffect, useState } from "react";
import Fillout from "./Fillout/Fillout";
import Estimate from "./Estimate/Estimate";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import routes from "../../routes/routes";
import api from "../../api/resources";
import { FormLoader } from "../commons/Form/Form";

export default function Request() {
  const navigate = useNavigate();
  const { requestID } = useParams();
  const [loading, setLoading] = useState(true);
  const { need: needFromLocation, usecase: usecaseFromLocation } =
    useRequestLocation();

  const [need, setNeed] = useState("");
  const [usecase, setUsecase] = useState("");
  const [id, setID] = useState(requestID === "new" ? 0 : requestID);
  const [edit, setEdit] = useState(true);

  const init = async () => {
    setLoading(true);

    if (requestID === "new") {
      if (!needFromLocation && !usecaseFromLocation) {
        navigate(routes.Financing.assess);
      } else {
        setNeed(needFromLocation);
        setUsecase(usecaseFromLocation);
      }
      // protect against user putting any string in the url
    } else if (
      !isNaN(Number(requestID)) && // check if not not a number
      parseInt(requestID) === Number(requestID) && // check if integer
      parseInt(Number(requestID)) > 0
    ) {
      const response = await api.getLoanRequest(requestID);
      if (response.ok) {
        const jsonResponse = await response.json();
        setNeed(jsonResponse.need);
        setUsecase(jsonResponse.use_case);
        setEdit(false);
      } else {
        navigate(routes.Financing.loans);
      }
    } else {
      navigate(routes.Financing.loans);
    }

    setLoading(false);
  };

  useEffect(() => {
    init();
  }, []);

  const handleEstimate = (newRequestID = id) => {
    setID(newRequestID);
    setEdit(false);
  };

  const handleEdit = () => setEdit(true);

  if (loading) return <FormLoader />;
  if (edit) {
    return (
      <Fillout
        need={need}
        usecase={usecase}
        patchID={id}
        onEstimate={handleEstimate}
      />
    );
  }

  return <Estimate loanRequestID={id} onEdit={handleEdit} />;
}

function useRequestLocation() {
  const location = useLocation();
  let [need, usecase] = "";
  if (location.state) {
    need = location.state.need;
    usecase = location.state.usecase;
  }

  return { need, usecase };
}
